import { AnalyticsQuery, type AnalyticsQueryWithResult } from "./AnalyticsQuery";
import type { QueryConfig } from "./QueryConfig";

export type AnalyticsContentTab = "result" | "history" | "examples";

export interface AnalyticsState {
	config: QueryConfig;
	isLoading: boolean;
	query: AnalyticsQuery;
	history: Array<AnalyticsQueryWithResult>;
	activeTab: AnalyticsContentTab;
}

export const initialAnalyticsState: AnalyticsState = {
	config: {
		timeout: 15,
	},
	isLoading: false,
	activeTab: "examples",
	query: new AnalyticsQuery(),
	history: [],
};
